export default __webpack_public_path__ + "static/media/tsuru.56b9950e.svg";